// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"e8c87b7c","100":"d3a30fe0","486":"09ea5d4c","546":"aadf6bf5"}[chunkId] + ".chunk.js";
};